import { render } from "./AnimatedIcon.vue?vue&type=template&id=4c82c431&ts=true"
import script from "./AnimatedIcon.vue?vue&type=script&lang=ts"
export * from "./AnimatedIcon.vue?vue&type=script&lang=ts"

import "./AnimatedIcon.vue?vue&type=style&index=0&id=4c82c431&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__